import { render, staticRenderFns } from "./fixRec.vue?vue&type=template&id=4f08c4b4&scoped=true"
import script from "./fixRec.vue?vue&type=script&lang=js"
export * from "./fixRec.vue?vue&type=script&lang=js"
import style0 from "./fixRec.vue?vue&type=style&index=0&id=4f08c4b4&prod&lang=scss&scoped=true"
import style1 from "./fixRec.vue?vue&type=style&index=1&id=4f08c4b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f08c4b4",
  null
  
)

export default component.exports